import { render, staticRenderFns } from "./SponsorCard.vue?vue&type=template&id=7720e10c&"
import script from "./SponsorCard.vue?vue&type=script&lang=js&"
export * from "./SponsorCard.vue?vue&type=script&lang=js&"
import style0 from "./SponsorCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports